

var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Functions = OCS.Functions || {};
OCS.Datasets = OCS.Datasets || {};

OCS.Functions.define_dataset = function () {
    return new Class({
        Implements: [Options],
        class_type: "Dataset",
        class_name: "Dataset",
        default_protocol: "https:",
        options: {
            "dataset": "",
            "datatype": "unknown",
            "node_path": "",
            "node_args": "",
            "name": "unknown",
            "node": true,
            "node_dataset": "",
            "provider": "",
            "gridded_avail": true,
            "dataURL": "",
            "dataUrls": {},
            "dataGriddedURL": "",
            "dataQueryURL": "",
            "resolution": 300000,
            "stale_threshold": 30 * 60 * 1000
        },
        initialize: function (op) {
            this.setOptions(op);
            // TO be removed when sni issues is resolved
            try {
                if (typeof (window) !== 'undefined' && window.location) {
                    this.default_protocol = window.location.protocol;
                }
            } catch (er) {

            }
        },
        getOption: function (option_name) {
            return this.options[option_name];
        },
        get_datatype: function () {
            return this.options.datatype;
        },
        get_node_path: function () {
            return this.options.node_path;
        },
        get_node_args: function () {
            return this.options.node_args;
        },
        get_node_dataset_name: function () {
            return this.options.node_dataset;
        },
        get_node_channel: function (options) {
            if (this.options.node && this.options.node_path) {
                return this.url_string_replace(this.options.node_path + this.options.node_args, options);
            }
            /* istanbul ignore next */
            return "";
        },
        get_string_keys: function (url) {
            return url.match(/[^{}]+(?!{)(?=})/g);
        },
        get_url: function (options, type) {
            if (type && this.options.dataUrls[type]) {
                return this.url_string_replace(this.options.dataUrls[type], options);
            }
            return this.url_string_replace(this.options.dataURL, options);
        },
        get_query_url: function (options) {
            return this.url_string_replace(this.options.dataQueryURL, options);
        },
        url_string_replace: function (url_str, options) {
            if (!options.protocol) {
                options.protocol = this.default_protocol;
            }
            if (!options.ocs_api_subdomain) {
                options.ocs_api_subdomain = OCS.Functions.get_ocs_api_subdomain();
            }
            if (!options.ocs_domain) {
                options.ocs_domain = OCS.Functions.get_ocs_domain();
            }
            if (!options.ocs_feeds_domain) {
                options.ocs_feeds_domain = OCS.Functions.get_ocs_feeds_domain();
            }

            var url = url_str;
            if (options && Object.keys(options).length) {
                Object.each(options, function (value, key) {
                    url = url.replace(new RegExp("{" + key + "}", 'g'), value);
                });
                // Clear any {key} that were not set
                url = url.replace(/{(?:\w)+}\/|{(?:\w)+}/g, '');
            }
            return url;
        },
        can_be_gridded: function () {
            return this.options.gridded_avail;
        },
        get_gridded_url: function () {
            if (this.can_be_gridded()) {
                return this.options.dataGriddedURL;
            }
        },
        get_resolution: function () {
            if (this.options.resolution > 0) {
                return this.options.resolution;
            } else {
                return 1;
            }
        },
        get_time_with_resultion: function (time) {
            time -= (time % this.get_resolution());
            return time;
        },
        get_end_time: function (time) {
            return this.get_time_with_resultion(time);
        },
        get_start_time: function (start_time) {
            return this.get_time_with_resultion(start_time);
        },

    });
};
OCS.Classes.Dataset = OCS.Functions.define_dataset();
if (OCS.Config && OCS.Config.datasets) {
    Object.each(OCS.Config.datasets, function (dataset, name) {
        OCS.Datasets[name] = new OCS.Classes.Dataset(dataset);
    });
}
try {
    if (typeof (module) !== 'undefined') {
        module.exports = OCS;
    }
} catch(e) {
    
}